<!-- xx页面 -->
<template>
  <div class='monthlyStatistics' ref="box">
    <div class="search" ref="topBox">
      <div class="box-left">
        <el-date-picker
          v-model="dateTime"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择月"
          >
        </el-date-picker>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <div class="chart">
      <div class="chartLeft">
        <div class="leftBoxTop">
          <div class="sleepState">
            <h3>睡眠状况统计</h3>
            <sleep-score :sleepScore="sleepScore"></sleep-score>
          </div>
          <div class="sleepClose">
            <h3>睡眠统计</h3>
            <div class="boxBig">
              <div class="sleepLeft">
                <sleep-breathe-week :breatheHeartRate="breatheHeartRate"></sleep-breathe-week>
              </div>
              <div class="contentSleep">
                <div>
                  <span>{{breatheHeartRate.avgHeartRate}}</span>次/分
                  <div>平均心率</div>
                </div>
                <div>
                  <span>{{breatheHeartRate.averageRespiratoryRate}}</span>次/分
                  <div>平均呼吸率</div>
                </div>
                <div class="colorBlue">
                  <span>{{breatheHeartRate.averageSleepDuration ? breatheHeartRate.averageSleepDuration.slice(0, 2) : '00'}}</span>时<span>{{breatheHeartRate.averageSleepDuration ? breatheHeartRate.averageSleepDuration.slice(3, 5) : '00'}}</span>分
                  <div>平均睡眠时长</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="leftBoxTop" style="margin-top: 20px;">
          <div class="sleepState">
            <h3>心率统计</h3>
            <heart-statistics :heartRateStatistics="heartRateStatistics"></heart-statistics>
            <div class="heartTitle">
              <div>平均心率</div>
              <div>{{breatheHeartRate.avgHeartRate}}次</div>
              <div :style="{color: breatheHeartRate.avgHeartRate < 60 ? '#FF474A' : breatheHeartRate.avgHeartRate >= 60&&breatheHeartRate.avgHeartRate <= 100 ? '#3F86FF' : '#FF474A'}">{{breatheHeartRate.avgHeartRate < 60 ? '偏低' : breatheHeartRate.avgHeartRate >= 60&&breatheHeartRate.avgHeartRate <= 100 ? '正常' : '偏高'}}</div>
            </div>
          </div>
          <div class="sleepClose">
            <h3>呼吸统计</h3>
            <breathe-statistics :heartRateStatistics="heartRateStatistics"></breathe-statistics>
            <div class="heartTitle">
              <div>平均呼吸率</div>
              <div>{{breatheHeartRate.averageRespiratoryRate}}次</div>
              <div :style="{color: breatheHeartRate.averageRespiratoryRate < 16 ? '#FF474A' : breatheHeartRate.averageRespiratoryRate >= 16&&breatheHeartRate.averageRespiratoryRate <= 20 ? '#3F86FF' : '#FF474A'}">{{breatheHeartRate.averageRespiratoryRate < 16 ? '偏低' : breatheHeartRate.averageRespiratoryRate >= 16&&breatheHeartRate.averageRespiratoryRate <= 20 ? '正常' : '偏高'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="chartRight">
        <div class="rightTop">
          <h3>睡眠时长</h3>
          <sleep-druation :sleepTime="sleepTime"></sleep-druation>
          <div class="time">
            <span> <i style="background-color: #514df1"></i> 深睡 </span>
            <span> <i style="background-color: #51aff2"></i> 中睡 </span>
            <span> <i style="background-color: #b1de58"></i> 浅睡 </span>
            <span> <i style="background-color: #f9c570"></i> 清醒 </span>
          </div>
          <div class="info">
            <div>
              <div>平均睡眠时长</div>
              <div>{{sleepTime.avgTime.kindOfTime}}</div>
              <div :style="{color: sleepTime.avgTime.score == '偏低' || sleepTime.avgTime.score == '偏高' ? '#FF474A' : '#3F86FF'}">{{sleepTime.avgTime.score}}</div>
            </div>
            <div>
              <div>平均深睡时长</div>
              <div>{{sleepTime.deepSleepTime.kindOfTime}}</div>
              <div :style="{color: sleepTime.deepSleepTime.score == '偏低' || sleepTime.deepSleepTime.score == '偏高' ? '#FF474A' : '#3F86FF'}">{{sleepTime.deepSleepTime.score}}</div>
            </div>
            <div>
              <div>平均中睡时长</div>
              <div>{{sleepTime.moderateSleepTime.kindOfTime}}</div>
              <div :style="{color: sleepTime.moderateSleepTime.score == '偏低' || sleepTime.moderateSleepTime.score == '偏高' ? '#FF474A' : '#3F86FF'}">{{sleepTime.moderateSleepTime.score}}</div>
            </div>
            <div>
              <div>平均浅睡时长</div>
              <div>{{sleepTime.lightSleepTime.kindOfTime}}</div>
              <div :style="{color: sleepTime.lightSleepTime.score == '偏低' || sleepTime.lightSleepTime.score == '偏高' ? '#FF474A' : '#3F86FF'}">{{sleepTime.lightSleepTime.score}}</div>
            </div>
            <div>
              <div>平均清醒时长</div>
              <div>{{sleepTime.soberTime.kindOfTime}}</div>
              <div :style="{color: sleepTime.soberTime.score == '偏低' || sleepTime.soberTime.score == '偏高' ? '#FF474A' : '#3F86FF'}">{{sleepTime.soberTime.score}}</div>
            </div>
          </div>
        </div>
        <div class="rightBottom">
          <h3>在床时长</h3>
          <physical-fitness :heartRateStatistics="heartRateStatistics"></physical-fitness>
          <div class="heartTitle">
            <div>平均在床时长</div>
            <div>{{abedDuration}}</div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import { debounce } from '@/utils/validate'
import sleepScore from "@/components/sleepMonitor/sleepScore"
import sleepBreatheWeek from "@/components/sleepMonitor/sleepBreatheWeek"
import heartStatistics from "@/components/sleepMonitor/heartStatistics"
import breatheStatistics from "@/components/sleepMonitor/breatheStatistics"
import sleepDruation from "@/components/sleepMonitor/sleepDruation"
import physicalFitness from "@/components/sleepMonitor/physicalFitness"
export default {
  // import引入的组件需要注入到对象中才能使用
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    },
  },
  components: {
    sleepScore,
    sleepBreatheWeek,
    heartStatistics,
    breatheStatistics,
    sleepDruation,
    physicalFitness,
  },
  data () {
    // 这里存放数据
    return {
      dateTime: '',
      dateTimeEnd: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()- 3600 * 1000 * 24; // 今天之前禁用，减去一天的毫秒数，否则今天也将禁用
        }
      },
      tableHeight: 'auto',
      sleepScore: {},
      breatheHeartRate: {},
      sleepTime: {},
      heartRateStatistics: [],
      abedDuration: '',
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // 初始化获取时间
    let date = new Date(); // 获取当前时间戳
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let day = date.getDate();
    day = day < 10 ? "0" + day : day;
    this.dateTime = year + "-" + month;
    this.handleSleepScore()
    this.handleSleepStatistics()
    this.handleSleepTime()
    this.handleHeartRateStatistics()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.makeheight()
    window.onresize = debounce(this.makeheight)
  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    // 动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight () {
      this.$nextTick(() => {
        let boxHeight = this.$refs.box.offsetHeight
        let topHeight = this.$refs.topBox.offsetHeight
        this.tableHeight = `${boxHeight - topHeight - 35}px`
      })
    },
    // 点击查询
    handleSearch () {
      this.handleSleepScore()
      this.handleSleepStatistics()
      this.handleSleepTime()
      this.handleHeartRateStatistics()
    },
     // 获取平均睡眠得分
    handleSleepScore () {
      this.request.post('/front/device/sleep/avgScore', {
        deviceId: this.deviceId,
        type: 2,
        month: this.dateTime + '-01',
      }).then(res => {
        if (res.code == 200) {
          this.sleepScore = res.data
        }
      })
    },
    // 获取睡眠统计数据
    handleSleepStatistics () {
      this.request.post('/front/device/sleep/sleepStatistics', {
        deviceId: this.deviceId,
        type: 2,
        month: this.dateTime + '-01',
      }).then(res => {
        if (res.code == 200) {
          this.breatheHeartRate = res.data
          this.breatheHeartRate.avgHeartRate = this.breatheHeartRate.avgHeartRate ? this.breatheHeartRate.avgHeartRate : '00'
          this.breatheHeartRate.averageRespiratoryRate = this.breatheHeartRate.averageRespiratoryRate ? this.breatheHeartRate.averageRespiratoryRate : '00'
        }
      })
    },
    // 获取睡眠时长数据
    handleSleepTime () {
      this.request.post('/front/device/sleep/mulSleep', {
        deviceId: this.deviceId,
        type: 2,
        month: this.dateTime + '-01',
      }).then(res => {
        if (res.code == 200) {
          this.sleepTime = res.data
          if (this.sleepTime.avgTime == null) {
            let obj = {
              kindOfTime: '00时00分',
              score: '偏低'
            }
            this.sleepTime.avgTime = obj
          } else {
            this.sleepTime.avgTime.kindOfTime = this.sleepTime.avgTime.kindOfTime ? this.sleepTime.avgTime.kindOfTime : '00时00分'
          }
          if (this.sleepTime.deepSleepTime == null) {
            // this.sleepTime.deepSleepTime.kindOfTime = '00时00分'
            let obj = {
              kindOfTime: '00时00分',
              score: '偏低'
            }
            this.sleepTime.deepSleepTime = obj
          } else {
            this.sleepTime.deepSleepTime.kindOfTime = this.sleepTime.deepSleepTime.kindOfTime ? this.sleepTime.deepSleepTime.kindOfTime : '00时00分'
          }
          if (this.sleepTime.moderateSleepTime == null) {
            // this.sleepTime.moderateSleepTime.kindOfTime = '00时00分'
            let obj = {
              kindOfTime: '00时00分',
              score: '偏低'
            }
            this.sleepTime.moderateSleepTime = obj
          } else {
            this.sleepTime.moderateSleepTime.kindOfTime = this.sleepTime.moderateSleepTime.kindOfTime ? this.sleepTime.moderateSleepTime.kindOfTime : '00时00分'
          }
          if (this.sleepTime.lightSleepTime == null) {
            // this.sleepTime.lightSleepTime.kindOfTime = '00时00分'
            let obj = {
              kindOfTime: '00时00分',
              score: '偏低'
            }
            this.sleepTime.lightSleepTime = obj
          } else {
            this.sleepTime.lightSleepTime.kindOfTime = this.sleepTime.lightSleepTime.kindOfTime ? this.sleepTime.lightSleepTime.kindOfTime : '00时00分'
          }
          if (this.sleepTime.soberTime == null) {
            // this.sleepTime.soberTime.kindOfTime = '00时00分'
            let obj = {
              kindOfTime: '00时00分',
              score: '偏低'
            }
            this.sleepTime.soberTime = obj
          } else {
            this.sleepTime.soberTime.kindOfTime = this.sleepTime.soberTime.kindOfTime ? this.sleepTime.soberTime.kindOfTime : '00时00分'
          }
          // this.sleepTime.avgTime.kindOfTime = this.sleepTime.avgTime.kindOfTime ? this.sleepTime.avgTime.kindOfTime : '00时00分'
          // this.sleepTime.deepSleepTime.kindOfTime = this.sleepTime.deepSleepTime.kindOfTime ? this.sleepTime.deepSleepTime.kindOfTime : '00时00分'
          // this.sleepTime.moderateSleepTime.kindOfTime = this.sleepTime.moderateSleepTime.kindOfTime ? this.sleepTime.moderateSleepTime.kindOfTime : '00时00分'
          // this.sleepTime.lightSleepTime.kindOfTime = this.sleepTime.lightSleepTime.kindOfTime ? this.sleepTime.lightSleepTime.kindOfTime : '00时00分'
          // this.sleepTime.soberTime.kindOfTime = this.sleepTime.soberTime.kindOfTime ? this.sleepTime.soberTime.kindOfTime : '00时00分'
        }
      })
    },
    // 获取心率统计数据
    handleHeartRateStatistics () {
      this.request.post('/front/device/sleep/queryStatistics', {
        deviceId: this.deviceId,
        type: 2,
        queryTime: this.dateTime + '-01' + ' 00:00:00',
      }).then(res => {
        if (res.code == 200) {
          this.heartRateStatistics = res.data 
          let abedDuration = 0
          let arr = []
          this.heartRateStatistics.forEach(item => {
            if (item.abedDuration == 0) {
              return
            } else {
              arr.push(item)
            }
          })
          if (arr.length == 0) {
            this.abedDuration = '00时00分'
          } else {
            arr.forEach(type => {
              abedDuration += type.abedDuration
            })
            this.abedDuration = parseInt(abedDuration / arr.length / 60) + '时' + (Math.ceil(parseInt(abedDuration / arr.length) % 60)) + '分'
          }
        }
      })
    },
    // 确定日期触发
    handleDetermine (time) {
      let date
      date = new Date(time);
      let weekDates
      weekDates = this.getWeekDates(date); // 获取本周一 本周日的日期
      weekDates.forEach((item, index) => {
        weekDates[index] = this.format(item);
      })
      // console.log(888, weekDates);
      this.dateTimeBegin = weekDates[0]
      this.dateTimeEnd = weekDates[1]
    },
    format (time) {
      let nowTime = new Date(time);
      let year = nowTime.getFullYear();
      let month =
        nowTime.getMonth() + 1 < 10
          ? "0" + (nowTime.getMonth() + 1)
          : nowTime.getMonth() + 1;
      let day =
        nowTime.getDate() < 10 ? "0" + nowTime.getDate() : nowTime.getDate();
      return year + "-" + month + "-" + day;
    },
    getWeekDates (date) {
      const weekDates = [];
      const dayOfWeek = date.getDay(); // 获取给定日期的星期几，0表示星期日，1表示星期一，以此类推
      // 计算本周一的日期
      const monday = new Date(date);
      monday.setDate(date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
      weekDates.push(monday);
      // // 计算本周日的日期
      const sunday = new Date(date)
      // 判断是周日的话设置当前
      if (dayOfWeek == 0) {
        sunday.setDate(date.getDate());
      } else {
        sunday.setDate(date.getDate() - dayOfWeek + 7);
      }
      weekDates.push(sunday);
      return weekDates;
    },
  }
}
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
.monthlyStatistics {
  height: 100%;
  width: 100%;
  .search {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .box-left {
      /deep/.el-date-editor {
        width: 135px;
        margin-right: 10px;
        .el-input__prefix {
          top: -4px !important;
        }
        .el-input__suffix {
          top: -4px !important;
        }
      }
      .el-button {
        padding: 0;
        height: 32px;
        width: 50px;
        background-color: #2177E6;
      }
    }
    .box-right {
      display: flex;

      >div{
        width: 70px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        margin-left: 15px;
        box-shadow: 0px 0px 8px #e6e6e6 inset;
        color: #7a7d81;
        border-radius: 3px;
      }
      .boxShow {
        box-shadow: 0px 0px 8px #2177e6 inset;
        color: #2177e6;
      }
    }
  }
  .chart {
    margin-top: 10px;
    height: calc(100% - 60px);
    background-color: #F4F7FA;
    border-radius: 12px;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    overflow-y: scroll;
    .chartLeft {
      width: 65%;
      height: 100%;
      .leftBoxTop {
        display: flex;
        justify-content: space-between;
        >div {
          width: 49%;
          height: 360px;
          padding: 15px;
          box-sizing: border-box;
          background-color: #fff;
          border-radius: 10px;
          position: relative;
          >h3 {
            font-family: AlibabaPuHuiTi-Bold;
          }
          .heartTitle {
            width: calc(100% - 30px);
            height: 40px;
            background: #E8EFFE;
            border-radius: 5px;
            position: absolute;
            line-height: 40px;
            bottom: 15px;
            display: flex;
            padding: 0 40px;
            box-sizing: border-box;
            justify-content: space-between;
            div:nth-child(1) {
              font-family: AlibabaPuHuiTi-Bold;
            }
            div:nth-child(2) {
              color: #457CFF;
            }
          }
        }
        .sleepClose {
          .boxBig {
            display: flex;
            .sleepLeft {
              width: 60%;
            }
            .contentSleep {
              width: 40%;
              padding-top: 40px;
              padding-left: 30px;
              box-sizing: border-box;
              >div {
                font-size: 12px;
                margin-bottom: 20px;
                span {
                  font-size: 30px;
                  font-family: AlibabaPuHuiTi-Bold;
                  color: #457CFF;
                }
                >div {
                  font-size: 12px;
                  color: #666666;
                }
              }
              .colorBlue {
                color: #457CFF;
              }
            }
          }
        }
      }
    }
    .chartRight {
      width: 35%;
      >div {
        margin-left: 20px;
        width: calc(100% - 20px);
        background-color: #fff;
        border-radius: 10px;
        padding: 15px;
        box-sizing: border-box;
        >h3 {
          font-family: AlibabaPuHuiTi-Bold;
        }
      }
      .rightTop {
        height: 400px;
        position: relative;
        .time {
          text-align: right;
          position: absolute;
          top: 40px;
          right: 30px;
          >span {
            color: #333;
            margin-left: 30px;
            i {
              display: inline-block;
              width: 15px;
              height: 6px;
              border-radius: 30px;
              vertical-align: 2px;
            }
          }
        }
        .info {
          width: 100%;
          height: 150px;
          background-color: #E8EFFE;
          border-radius: 10px;
          padding: 15px 30px;
          box-sizing: border-box;
          >div {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            div:nth-child(1) {
              font-family: AlibabaPuHuiTi-Bold;
            }
            div:nth-child(2) {
              color: #457CFF;
            }
          }
        }
      }
      .rightBottom {
        height: 320px;
        margin-top: 20px;
        position: relative;
        .heartTitle {
          width: calc(100% - 30px);
          height: 40px;
          background: #E8EFFE;
          border-radius: 5px;
          position: absolute;
          line-height: 40px;
          bottom: 15px;
          display: flex;
          padding: 0 40px;
          box-sizing: border-box;
          justify-content: space-between;
          div:nth-child(1) {
            font-family: AlibabaPuHuiTi-Bold;
          }
          div:nth-child(2) {
            color: #457CFF;
          }
        }
      }
    }
  }
}
</style>
